import { useState } from "react";
import { Gift, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, gbp, fmtDate } from "../lib/api";

export function VoucherApply({ value, onChange }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const check = async () => {
    setBusy(true);
    try { const { data } = await api.post("/vouchers/check", { code }); onChange(data); toast.success(`Voucher applied: ${gbp(data.balance)} available`); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (value) return (
    <div className="flex items-center gap-2 text-sm rounded-xl bg-[#FFF1EE] px-3 py-2" data-testid="voucher-applied"><Gift size={14} className="text-[#FF8166]" />
      <span className="flex-1">Gift voucher <b>{value.code}</b>: {gbp(value.balance)} will be used first (valid until {fmtDate(value.expires_at)})</span>
      <button onClick={() => onChange(null)} className="btn-ghost btn-sm" aria-label="Remove voucher" data-testid="voucher-remove-btn"><X size={14} /></button></div>
  );
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm" data-testid="voucher-apply">
      <Gift size={14} className="text-[#FF8166]" /><span className="muted">Have a gift voucher?</span>
      <input className="input py-1.5 w-44 font-mono uppercase" placeholder="MHH-XXXX-XXXX" value={code} onChange={(e) => setCode(e.target.value)} data-testid="voucher-code-input" />
      <button onClick={check} disabled={busy || code.length < 8} className="btn-ghost btn-sm" data-testid="voucher-apply-btn">Apply</button>
    </div>
  );
}
